// LocaleContext.tsx
"use client";
import { create } from "zustand";

export enum Language {
  GEORGIAN = "ka",
  ENGLISH = "en",
  ITALIAN = "it",
}

interface LocaleStore {
  locale: Language;
  setLocale: (lang: Language) => void;
  initLocaleLoading: boolean;
  setInitLocaleLoading: (loading: boolean) => void;
}

export const useLocaleStore = create<LocaleStore>((set) => ({
  locale: Language.GEORGIAN,
  initLocaleLoading: true,
  setLocale: (lang: Language) => {
    if (typeof window !== "undefined") {
      document.documentElement.lang = lang;
    }
    set({ locale: lang });
  },
  setInitLocaleLoading: (loading: boolean) =>
    set({ initLocaleLoading: loading }),
}));

// Move initialization to a separate function that can be called from components
export const initializeLocale = () => {
  if (typeof window !== "undefined") {
    const htmlLang = document.documentElement.lang;
    if (Object.values(Language).includes(htmlLang as Language)) {
      useLocaleStore.getState().setLocale(htmlLang as Language);
      useLocaleStore.getState().setInitLocaleLoading(false);
    }
  }
};

// Keep the same interface as before with useLocale hook
export const useLocale = () => {
  const locale = useLocaleStore((state) => state.locale);
  const setLocale = useLocaleStore((state) => state.setLocale);
  const initLocaleLoading = useLocaleStore((state) => state.initLocaleLoading);

  return { locale, setLocale, initLocaleLoading };
};
